export const TYPES = {
  MULTIPLE: "multiple",
  CHECKBOX: "checkbox",
  RADIO: "radio",
  ITEMS: "items",
  SORT: "sort"
};
